export default "__VITE_ASSET__DC6hDo6l__"